import {
    Alert,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormGroup,
    Snackbar,
    TextField,
    Stack,
    Typography,
    useMediaQuery
} from "@mui/material";
import {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";


const Contact = () => {
    const theme = useTheme();
    const navigate = useNavigate()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const {t} = useTranslation();

    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        cellulare: "",
        info: "",
        privacy: false,
    });

    const [loading, setLoading] = useState(false); // Stato per mostrare caricamento
    const [error, setError] = useState(null); // Stato per errori
    const [success, setSuccess] = useState(false); // Stato per successo
    const [alertMessage, setAlertMessage] = useState(""); // Messaggio per l'alert

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    // Controlla se tutti i campi richiesti sono compilati
    const isFormValid = formData.nome.trim() !== "" && formData.email.trim() !== "";

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        const payload = {
            email: formData.email,
            nome: formData.nome,
            cellulare: formData.cellulare,
            info: formData.info,
            privacy: formData.privacy,
        };

        try {
            await fetch("https://hook.eu2.make.com/052rx5xzu1lvn1yhoeatb7iunpbvgt2m", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            })

            setSuccess(true);
            setAlertMessage("Contatto registrato con successo!");

            setFormData({
                nome: "",
                email: "",
                cellulare: "",
                info: "",
            });

            // Navigate to Thank You page
            navigate('/thankyou', { replace: true });
        } catch (error) {
            setError(error.message || "Errore imprevisto");
            setAlertMessage(`Errore: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };


    return(
        <Box
            sx={{
                width: '100vw',
                height: '90vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'linear-gradient(360deg, #F95F43 0%, #F1417A 100%)',
                marginTop:'75px',
                overflow:'hidden'
            }}
        >
            <Stack height={'100%'} alignItems={'left'} justifyContent={'center'} spacing={2}>
                <Typography variant={isMobile? 'h3' : 'h2'} mt={5}>
                    {t('contattaci.title')}
                </Typography>
                <Typography variant={'h4'}>
                    {t('contattaci.subtitle')}
                </Typography>
                <Typography variant={'h4'}>
                    {t('contattaci.writeTo')} <a href={"mailto:hello@plesh.co"} target={"_blank"}
                    style={{background: "white", paddingLeft: "6px", paddingRight: "6px", borderRadius: '10px', color: '#f44c67'}}
                >
                    hello@plesh.co
                </a>
                </Typography>
            </Stack>
            {/*<form
                onSubmit={handleSubmit}
                style={{
                    width: isMobile ? '90%' : '45%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '5vh 0',
                }}
            >
                <TextField
                    required
                    fullWidth
                    placeholder={t('contattaci.nome')+"*"}
                    name="nome"
                    variant="outlined"
                    value={formData.nome}
                    onChange={handleChange}
                />
                <TextField
                    required
                    fullWidth
                    placeholder="E-mail*"
                    name="email"
                    type="email"
                    variant="outlined"
                    value={formData.email}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    placeholder={t('contattaci.numero')}
                    name="cellulare"
                    type="tel"
                    variant="outlined"
                    value={formData.cellulare}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    placeholder={t('contattaci.note')}
                    name="info"
                    variant="outlined"
                    multiline
                    rows={4}
                    value={formData.info}
                    onChange={handleChange}
                />

                <FormControl component="fieldset">
                    <FormGroup>
                        <FormControlLabel
                            value="bottom"
                            control={<Checkbox
                                name="privacy"
                                checked={formData.privacy}
                                onChange={(e) => setFormData({...formData, privacy: e.target.checked})}
                            />}
                            label={t('contattaci.privacy')}
                        />
                    </FormGroup>
                </FormControl>

                <Box sx={{height:'70px'}}>
                    {loading ?

                        <CircularProgress color={'#fff'} sx={{marginTop:'1rem'}}/>
                        :
                        <Button
                            variant="empty"
                            color="primary"
                            type="submit"
                            sx={{marginTop: '1rem'}}
                            disabled={!isFormValid || loading}
                        >
                            {t('contattaci.action')}
                        </Button>
                    }
                </Box>

            </form>*/}

            <Footer />
            <Snackbar
                open={success || error !== null}
                autoHideDuration={6000}
                onClose={() => {
                    setSuccess(false);
                    setError(null);
                }}
            >
                <Alert
                    onClose={() => {
                        setSuccess(false);
                        setError(null);
                    }}
                    severity={success ? "success" : "error"}
                    sx={{width: '100%'}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </Box>
    )
}

export default Contact;
